import { Checkbox, FormControlLabel } from '@mui/material';
import { requiredLabel } from 'utils/form';
import { getFieldControlSx } from '../fieldStyles';
import type { FieldRendererProps } from '../types';

export function CheckboxField({
  field,
  className,
  sx,
  hasWhiteFields = false,
  isDisabled,
  isReadOnly,
  onChange,
}: FieldRendererProps) {
  return (
    <FormControlLabel
      className={className}
      sx={getFieldControlSx(hasWhiteFields, sx)}
      control={
        <Checkbox
          readOnly={isReadOnly}
          color="secondary"
          disabled={isDisabled}
          checked={field.value === 'on'}
          onChange={(event) => onChange(event.target.checked ? 'on' : '')}
          name={field.label}
        />
      }
      label={requiredLabel(field.label, field.required)}
    />
  );
}
